import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {useQuery} from '@apollo/client';
import gql from 'graphql-tag';
import {DateTime} from 'luxon';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import AddIcon from '@material-ui/icons/Add';

import { PermissionOnly } from './AdminOnly';
import * as theme from '../theme';

const useStyles = makeStyles({
    topBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 16,
        height: 56,
        padding: '0 24px',
        borderBottom: `1px solid ${theme.gray30}`,
        backgroundColor: theme.white,
        flexShrink: 0,
    },
    buzzouts: {
        color: 'maroon',
        fontSize: 13,
        lineHeight: 1.3,
        textAlign: 'right',
        marginRight: 16,
    },
    avatar: {
        width: 44,
        height: 44,
    },
});

const StyledBadge = withStyles(() => ({
    badge: {
        backgroundColor: '#7FFF00',
        padding: 0,
        opacity: 0.7,
    },
}))(Badge);

export default function TopBar({installation, appConfig}) {
    const classes = useStyles();

    const {data: dataByDate} = useQuery(
        gql`
            query Analytics($installationId: ID!, $date: String!) {
                getDataByDate(installationId: $installationId, date: $date) {
                    buzzOutByDate {
                        count
                        amount
                    }
                }
            }
        `,
        {
            variables: {
                installationId: installation.id,
                date: DateTime.now().setZone(installation.timeZoneName).toFormat('yyyy-MM-DD'),
            },
            fetchPolicy: 'no-cache',
            pollInterval: 5 * 60 * 1000,
        }
    );

    const buzzOut = dataByDate?.getDataByDate?.buzzOutByDate;

    const avatarSrc = appConfig && installation?.brandingKey
        ? `${appConfig.APPLICATION_ASSETS_URL}/images/${installation.brandingKey}/square_200x200.png`
        : undefined;

    return (
        <div className={classes.topBar}>
            <PermissionOnly>
                {buzzOut?.amount > 0 && (
                    <div className={classes.buzzouts}>
                        Buzzouts Today<br/>
                        Loss: ${buzzOut.amount.toLocaleString()} &nbsp; Cars: {buzzOut.count}
                    </div>
                )}
            </PermissionOnly>
            {avatarSrc && (
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    badgeContent={<AddIcon fontSize="small"/>}
                >
                    <Avatar alt={installation.name || 'Hotel'} className={classes.avatar} src={avatarSrc}/>
                </StyledBadge>
            )}
        </div>
    );
}